// src/utils/navigationConfig.js

// Country-specific navigation configurations
export const countryConfigs = {
  us: {
    name: 'United States',
    flag: '🇺🇸',
    code: 'us',
    subdivisionLabel: 'States', // States, Provinces, Kingdoms, etc.
    branches: [
      {
        id: 'legislative',
        title: 'Legislative',
        path: '/us/legislative',
        icon: 'pen',
        description: 'Congress, bills, and laws'
      },
      {
        id: 'executive', 
        title: 'Executive',
        path: '/us/executive',
        icon: 'people',
        description: 'President and executive departments'
      },
      {
        id: 'judicial',
        title: 'Judicial',
        path: '/us/judicial', 
        icon: 'gavel',
        description: 'Federal courts and legal decisions'
      }
    ],
    topics: [
      { id: 'defense', title: 'Defense', path: '/us/defense', icon: 'shield' },
      { id: 'economy', title: 'Economy', path: '/us/economy', icon: 'coin' },
      { id: 'election', title: 'Elections', path: '/us/elections', icon: 'receipt' },
      { id: 'environment', title: 'Environment', path: '/us/environment', icon: 'tree' },
      { id: 'foreignaffairs', title: 'Foreign Affairs', path: '/us/foreignaffairs', icon: 'globe' },
      { id: 'health', title: 'Health', path: '/us/health', icon: 'heart-pulse' },
      { id: 'infrastructure', title: 'Infrastructure', path: '/us/infrastructure', icon: 'building' },
      { id: 'justice', title: 'Justice', path: '/us/justice', icon: 'person-arms-up' },
      { id: 'science&tech', title: 'Science & Tech', path: '/us/science&tech', icon: 'rocket' },
      { id: 'spending', title: 'Spending', path: '/us/spending', icon: 'dollar-sign' },
      { id: 'regulations', title: 'Regulations', path: '/us/regulations', icon: 'file-text' },
      { id: 'immigration', title: 'Immigration', path: '/us/immigration', icon: 'passport' }
    ],
    departments: [
      'departmentofdefense',
      'departmentofagriculture', 
      'departmentofcommerce',
      'departmentofstate',
      'departmentoftransportation',
      'departmentofjustice',
      'departmentoftreasury',
      'departmentoftheinterior',
      'departmentoflabor',
      'departmentofhealth',
      'departmentofhousing',
      'departmentofeducation'
    ]
  },

  // Canada config - accessible by both 'ca' and 'canada' keys
  ca: {
    name: 'Canada',
    flag: '🇨🇦',
    code: 'ca',
    subdivisionLabel: 'Provinces',
    branches: [
      {
        id: 'legislative',
        title: 'Legislative',
        path: '/canada/legislative',
        icon: 'pen',
        description: 'Parliament and provincial legislatures'
      },
      {
        id: 'executive', 
        title: 'Executive',
        path: '/canada/executive',
        icon: 'people',
        description: 'Prime Minister and cabinet'
      },
      {
        id: 'judicial',
        title: 'Judicial',
        path: '/canada/judicial', 
        icon: 'gavel',
        description: 'Supreme Court and federal courts'
      }
    ],
    topics: [
      { id: 'economy', title: 'Economy', path: '/canada/economy', icon: 'coin' },
      { id: 'environment', title: 'Environment', path: '/canada/environment', icon: 'tree' },
      { id: 'foreignaffairs', title: 'Foreign Affairs', path: '/canada/foreignaffairs', icon: 'globe' },
      { id: 'science&tech', title: 'Science & Tech', path: '/canada/science&tech', icon: 'rocket' }
    ],
    departments: [] // Canada uses ministries, could be added later
  },

  // Mexico config - accessible by both 'mx' and 'mexico' keys
  mx: {
    name: 'Mexico',
    flag: '🇲🇽',
    code: 'mx',
    subdivisionLabel: 'States',
    branches: [
      {
        id: 'legislative',
        title: 'Legislative',
        path: '/mexico/legislative',
        icon: 'pen',
        description: 'Congress and state legislatures'
      },
      {
        id: 'executive', 
        title: 'Executive',
        path: '/mexico/executive',
        icon: 'people',
        description: 'President and federal government'
      },
      {
        id: 'judicial',
        title: 'Judicial',
        path: '/mexico/judicial', 
        icon: 'gavel',
        description: 'Supreme Court and federal judiciary'
      }
    ],
    topics: [
      { id: 'defense', title: 'Defense', path: '/mexico/defense', icon: 'shield' },
      { id: 'economy', title: 'Economy', path: '/mexico/economy', icon: 'coin' },
      { id: 'environment', title: 'Environment', path: '/mexico/environment', icon: 'tree' },
      { id: 'foreignaffairs', title: 'Foreign Affairs', path: '/mexico/foreignaffairs', icon: 'globe' },
      { id: 'health', title: 'Health', path: '/mexico/health', icon: 'heart-pulse' },
      { id: 'infrastructure', title: 'Infrastructure', path: '/mexico/infrastructure', icon: 'building' },
     
    ],
    departments: [] // Mexico uses secretarías, could be added later
  },

  uk: {
    name: 'United Kingdom',
    flag: '🇬🇧',
    code: 'uk',
    subdivisionLabel: 'Kingdoms',
    subdivisions: [
      { code: 'england', name: 'England' },
      { code: 'scotland', name: 'Scotland' },
      { code: 'wales', name: 'Wales' },
      { code: 'northernireland', name: 'Northern Ireland' }
    ],
    branches: [
      { id: 'legislative', title: 'Legislative', path: '/uk/legislative', icon: 'pen', description: 'Parliament and devolved assemblies' },
      { id: 'executive', title: 'Executive', path: '/uk/executive', icon: 'people', description: 'Prime Minister and government' },
      { id: 'judicial', title: 'Judicial', path: '/uk/judicial', icon: 'gavel', description: 'Supreme Court and court system' }
    ],
    topics: [
      { id: 'defense', title: 'Defense', path: '/uk/defense', icon: 'shield' },
      { id: 'economy', title: 'Economy', path: '/uk/economy', icon: 'coin' },
      { id: 'environment', title: 'Environment', path: '/uk/environment', icon: 'tree' },
      { id: 'foreignaffairs', title: 'Foreign Affairs', path: '/uk/foreignaffairs', icon: 'globe' },
      { id: 'health', title: 'Health', path: '/uk/health', icon: 'heart-pulse' },
      { id: 'infrastructure', title: 'Infrastructure', path: '/uk/infrastructure', icon: 'building' },
      { id: 'justice', title: 'Justice', path: '/uk/justice', icon: 'person-arms-up' },
      { id: 'science&tech', title: 'Science & Tech', path: '/uk/science&tech', icon: 'rocket' }
    ],
    departments: []
  }
  
};

// Create aliases for country configs (canada -> ca, mexico -> mx)
countryConfigs.canada = countryConfigs.ca;
countryConfigs.mexico = countryConfigs.mx;
countryConfigs.united_kingdom = countryConfigs.uk;

// Available countries for country selector
export const availableCountries = [
  { code: 'all', name: 'All Countries', flag: '🌐', path: '/all' },
  { code: 'us', name: 'United States', flag: '🇺🇸', path: '/us' },
  { code: 'ca', name: 'Canada', flag: '🇨🇦', path: '/canada' },
  { code: 'mx', name: 'Mexico', flag: '🇲🇽', path: '/mexico' },
  { code: 'uk', name: 'United Kingdom', flag: '🇬🇧', path: '/uk' }
];

// Utility navigation items (same for all countries)
export const utilityNavItems = [
  { id: 'home', title: 'Home', path: '/', icon: 'house' },
  { id: 'fact-check', title: 'Fact Checker', path: '/fact-check', icon: 'fact' },
  { id: 'notifications', title: 'Notifications', path: '/notifications', icon: 'bell' },
  { id: 'collection', title: 'Collection', path: '/collection', icon: 'folder' },
  { id: 'search', title: 'Search', path: '/search', icon: 'search' },
  { id: 'about', title: 'About', path: '/about', icon: 'info' },
  { id: 'privacy', title: 'Privacy', path: '/privacy', icon: 'lock' },
  { 
    id: 'donate', 
    title: 'Donate', 
    path: 'https://donate.stripe.com/28o3fXbdvbQO2RO288', 
    icon: 'heart-fill',
    external: true,
    className: 'text-danger'
  }
];

// Normalize country code to match config keys
const normalizeCountryCode = (countryCode) => {
  if (!countryCode) return 'us';
  
  const normalizations = {
    'united_states_of_america': 'us',
    'united_states': 'us',
    'usa': 'us',
    'united_kingdom': 'uk',
    // These are now handled by aliases above, but keep for safety
    'canada': 'ca',
    'mexico': 'mx'
  };
  
  return normalizations[countryCode.toLowerCase()] || countryCode.toLowerCase();
};

// Helper functions
export const getCountryConfig = (countryCode) => {
  // Direct lookup first (handles 'canada', 'mexico' via aliases)
  if (countryConfigs[countryCode]) {
    return countryConfigs[countryCode];
  }
  
  // Try normalized lookup
  const normalized = normalizeCountryCode(countryCode);
  return countryConfigs[normalized] || countryConfigs.us;
};

export const getCountryFlag = (countryCode) => {
  return getCountryConfig(countryCode).flag;
};

export const getCountryName = (countryCode) => {
  return getCountryConfig(countryCode).name;
};

export const getSubdivisionLabel = (countryCode) => {
  return getCountryConfig(countryCode).subdivisionLabel;
};